<template>
  <div class="body"> 
    <div class="bigTitley bigTitleOne" v-scroll-animate="'slide-itemgk'">
      <div class="chineseA">
        <a href="/business" style="color: #333333;">业务板块</a> 
      </div>
      <div class="englishA"> 
        <a href="/business" class="animationcss0">Business</a>
      </div>
      
     
    </div>

  <div class="container1y element">

    
    
    
  
     <div class="rowDiv"> 
      
      <div class="flexItem" v-for="(item,index) in panels" :key="index" @click="navigateToDetail(index)" v-scroll-animate="'slide-item'+(index+1)">
        <a @mouseover="indexNum =(index+1)"  :class="(indexNum==(index+1))?'activeflexItem flexItemA'+(index+1):''" >
          <div>
            <img :src="urlBase+item.icon.slice(1)"   />
          </div>
          <div :class="(indexNum==index)?'txt1':''" >
            {{ item.explains }}
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import API from '@/api/bsInfo'

export default {
  data() {
    return {
      urlBase: process.env.VUE_APP_BASE_API,
      indexNum:1,
      panels:[]
    }
  },
  mounted() {
     
     this.getList()    
   
   },
  methods: {
    

    
   //获取业务板块首页内容
async getList() {
  try {
    let objParams={
      catId:'9e6274e05d4e40438c4a357704e3c56d'
    }
    const res = await API.getBusiness(objParams)
    this.panels = res.data.businessList
    console.log('获取成功', res.data.resultData)
  } catch (error) {
    console.error('获取失败', error)
  }
},
  navigateToDetail(index){
    
    const encodedTitle = encodeURIComponent(this.panels[index].explains)
    this.$router.push({
        path: '/businessDetail',
        query: {                     
          title: encodedTitle 
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped> 

.body{
  .bigTitley {
  font-size: 30px;
  color: #333;
  text-align: center;
  line-height: 6rem;
 
  a{
    font-size: 30px;
  }
  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
    a{
      font-size: 1.2rem;
    }
  }
  }
}
.container1y {
  background:url('../../assets/w/img3/shouye/wuliu-bg.png');
  background-size:cover;
  min-height: 40vw;
  width: 100vw;
  // background: red;
  margin: 0px auto;
  position: relative;
  transition: all .4s ease;
  @media screen and (max-width: 768px) {
    background-size:cover;
    min-height: 60vw;
  }
}
  

.rowDiv{
  width: 90vw;
  margin:0 auto;
  min-height: 10vw;
  position: absolute;
  z-index: 1;
  bottom: 6%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1px; /* 设置间距宽度 */
    @media screen and (max-width: 768px) {
      bottom: 30%;
       width: 99vw;
    }

  
  .flexItem{
    flex: 1;
    min-width: 1;
    aspect-ratio: 1 / 1; /* 宽高比1:1 */
    background-position: center 30%; /* 图片居中 */
    background-repeat: no-repeat; /* 不重复 */
    background-size: 33% auto; /* 相对于容器尺寸 */
    // background: #333;
    a{
      display: block;
      width: 100%;
      height: 100%;
      text-align: center;
      background-color: rgba(251, 250, 250, 0.809) !important;
      padding-top:22%;
      font-size: 25px;
      color: #333333;
     
      // opacity: 0.8;
      div{
        color: #333333;
        font-size:1.2rem;
        font-weight: bold;
        line-height: 3rem;
        @media screen and (max-width: 768px) {
            font-size: 8px;
             font-weight: normal;
              line-height:1rem;
        }
        img{
          filter: brightness(0);
          width: 30%;
        }
      }
    }
    a.activeflexItem{
     
      div{
        color: #ffffff;
        img{
          filter: brightness(0) invert(1);
        }
      }
    }
    a:hover{
      // background-color: rgb(64, 69, 229,0.5);  
      background: linear-gradient(to right top, rgb(64, 69, 229,0.8), rgba(160, 162, 239, 0.8));
      color: #ffffff;
    }
    
  }
   

  .flexItem:nth-child(1){
   
    a:hover{
      background: linear-gradient(to right top, rgba(74, 232, 30, 1), rgb(207, 243, 87,1)) !important;

      // background: linear-gradient(45deg, rgba(74, 232, 30, 1), rgb(207, 243, 87));
    }
  }
  .flexItem:nth-child(2){
    a:hover{
      background: linear-gradient(to right top, rgb(64, 69, 229,1), rgb(158, 161, 237,1));
    }
  }
  .flexItem:nth-child(3){
    a:hover{
      background: linear-gradient(to right top, rgba(232, 74, 30, 1), rgb(242, 179, 167,1));
    }
  }
  .flexItem:nth-child(4){
    a:hover{
      background: linear-gradient(to right top, rgba(8, 162, 179, 1), rgb(182, 233, 244,1));
    }
  }
  .flexItem:nth-child(5){
    a:hover{
      background: linear-gradient(to right top, rgb(155, 8, 168,1), rgb(238, 150, 213,1));
    }
  }
  .flexItem:nth-child(6){
    a:hover{
      background: linear-gradient(to right top, rgb(64, 69, 229,1), rgb(158, 161, 237,1));
    }
  }
  .flexItem:nth-child(7){
    a:hover{
      background: linear-gradient(to right top, rgba(232, 74, 30, 1), rgb(242, 179, 167,1));
    }
  }

  .flexItemA1{
      background: linear-gradient(to right top, rgba(74, 232, 30, 0.9), rgba(199, 245, 150, 0.9));
    }
  .flexItemA2{
    background: linear-gradient(to right top, rgb(64, 69, 229,0.9), rgba(187, 189, 243, 0.9));
  }
  .flexItemA3{
    background: linear-gradient(to right top, rgba(232, 74, 30, 0.9), rgba(246, 199, 187, 0.9));
  }
  .flexItemA4{
    background: linear-gradient(to right top, rgba(8, 162, 179, 0.9), rgba(187, 239, 246, 0.9));
  }
  .flexItemA5{
    background: linear-gradient(to right top, rgb(155, 8, 168, 0.9), rgb(238, 150, 213, 0.9));
  }
  .flexItemA6{
    background: linear-gradient(to right top, rgb(64, 69, 229,0.9), rgba(187, 189, 243, 0.9));
  }
  .flexItemA7{
    background: linear-gradient(to right top, rgba(232, 74, 30, 0.9), rgba(246, 199, 187, 0.9));
  }
  .txt1{
    color: #ffffff;
    
  }
   
}
.btn{
width: 50px;
height: 50px;
line-height: 50px;
border-radius: 50%;
background: #ffffff;
color: #333333;
overflow: hidden; /* 隐藏超出容器的部分 */
position: relative;
.sliding-text {
display: inline-block;
position: relative;
animation: slideRight 5s linear infinite;
}
@keyframes slideRight {
0% {
  transform: translateX(-100%);
}
100% {
  transform: translateX(100%);
}
}
}

.infinite-slider {
width: 50px;
overflow: hidden;
position: relative;
float: right;
margin-top: 300px;
margin-right: 150px;
height: 50px; /* 根据内容调整 */
line-height: 50px;
border-radius: 50%;
background: #ffffff;
color:#333333;

}

.sliding-content {
position: absolute;
white-space: nowrap;
animation: infiniteSlide 1s linear infinite;
}

@keyframes infiniteSlide {
0% {
  left: -10%;
 
  transform: translateX(0);

 
}
100% {
  left: 110%;
  transform: translateX(-100%);
}
}

.element {
position: relative;
overflow: hidden;
}
.element::before {
content: '';
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-image: url('../../assets/w/img3/shouye/wuliu-bg.png');
background-size: cover;
transition: opacity 1s ease-in-out;
}


.element:hover::before {
opacity: 0;
}

.element::after {
content: '';
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-image: url('../../assets/w/img3/shouye/wuliu-bg1.png');
background-size: cover;
opacity: 0;
transition: opacity 1s ease-in-out;
}

.element:hover::after {
opacity: 1;
}

</style>